import React, { ReactElement } from "react";
import * as Middleware from "@middlewares/index";

const InTouch = (): ReactElement => {
  return (
    <>
      <div className="modal modal--in-touch">
        <div className="col-left">
          <div className="modal__header">
            <div className="modal__title">OTM на связи!</div>
            <button
              className="modal__close"
              onClick={() => {
                Middleware.Ui.Modal.close();
              }}
            />
          </div>
          <div className="modal__body">
            <div className="modal__desc">
              Подписывайтесь на Telegram-канал выставки, чтобы быть в курсе
              событий и легко ориентироваться в возможностях мероприятия
            </div>
            <a
              className="btn btn--red btn--large"
              href="https://t.me/otm_tourism"
              target="_blank"
            >
              Перейти на канал
            </a>
          </div>
        </div>
        <div className="col-right">
          <a
            className="logo-telegram"
            href="https://t.me/otm_tourism"
            target="_blank"
          >
            <img
              src={require("@public/images/logo_telegram.svg")}
              alt="telegram"
            />
          </a>
        </div>
      </div>
    </>
  );
};

export default InTouch;
